import React, { useState } from "react";

import Carousel from "components/common/Carousel";

import envs from "config/envs";

import * as S from "./CnpAssurancePresenceInfo.style";

const CnpAssurancePresenceInfo = () => {
  const sliders = [
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/map_insured.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/icon_insured.webp`,
      title: "+ 50 milhões",
      description: "de pessoas seguradas.",
      alt: "+ 50 milhões de pessoas seguradas.",
      activeKey: "insured",
    },
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/map_customers.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/icon_customers.webp`,
      title: "36 milhões",
      description: "de clientes em previdência e proteção ao crédito.",
      alt: "Temos 36 milhões de clientes em previdência e proteção ao crédito.",
      activeKey: "customers",
    },
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/map_innovation.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/icon_innovation.webp`,
      title: "170 anos",
      description: "com a tradição de inovar",
      alt: "São 170 anos com a tradição de inovar",
      activeKey: "innovation",
    },
    {
      map: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/map_holding.webp`,
      icon: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/icon_partnership.webp`,
      title: "+ 300 parceiros",
      description: "distribuidores em 2 continentes",
      alt: "+ 300 parceiros distribuidores em 2 continentes",
      activeKey: "partnership",
    },
  ];

  const [map, setMap] = useState({
    img: `${envs.HOST_STATIC_CDN}/AreaAberta/Images/map_insured.webp`,
    alt: sliders[0].alt,
  });

  const [active, setActive] = useState(sliders[0].activeKey);

  const slidesMobile = (
    <>
      {sliders.map((slide, index) => {
        return (
          <S.SlideCard
            key={index}
            icon={slide.icon}
            map={slide.map}
            alt={slide.alt}
            title={slide.title}
            description={slide.description}
          />
        );
      })}
    </>
  );

  const handleUpdateSlide = (newMap, newAlt, newActive) => {
    setMap({
      img: newMap,
      alt: newAlt,
    });
    setActive(newActive);
  };

  const Title = (
    <>
      Mais que números, <br /> pessoas.
    </>
  );

  return (
    <S.Content>
      <S.DesktopOnly>
        <S.Container>
          <S.ContainerImage
            width="auto"
            height="auto"
            src={map.img}
            alt={map.alt}
          />
          <S.ContainerContent>
            <S.Title variant="headline-02" color="primary-dark">
              {Title}
            </S.Title>

            {sliders.map((slide, index) => {
              return (
                <S.CardInfo
                  key={index}
                  onMouseOver={() =>
                    handleUpdateSlide(slide.map, slide.alt, slide.activeKey)
                  }
                  active={active === slide.activeKey ? true : false}
                >
                  <S.CardIcon
                    width="auto"
                    height="auto"
                    src={slide.icon}
                    alt={slide.alt}
                  />
                  <S.CardContainer>
                    <S.CardTitle variant="headline-03">
                      {slide.title}
                    </S.CardTitle>
                    <S.Description>{slide.description}</S.Description>
                  </S.CardContainer>
                </S.CardInfo>
              );
            })}
          </S.ContainerContent>
        </S.Container>
      </S.DesktopOnly>

      <S.MobileOnly>
        <S.Title variant="headline-02" color="primary-dark">
          {Title}
        </S.Title>
        <Carousel children={slidesMobile.props.children} />
      </S.MobileOnly>
    </S.Content>
  );
};

export default CnpAssurancePresenceInfo;
